import { Injectable } from '@angular/core';
import { HttpBackend, HttpRequest, HttpClient, HttpParams, HttpHeaders } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { SEND_OTP_URL, VERIFY_OTP_URL, GET_ACCESSTOKEN_URL } from '../../@shared/config/sp-constant';
import { Observable } from 'rxjs';
import { ISendOtpResponseMapper, ISignInResponseMapper } from '@app/@shared/Models/signIn.model';
import { tap } from 'rxjs/operators';
import { v4 as uuidv4 } from 'uuid';
import { InstrumentationService } from '@app/@core/services/instrumentation/instrumentation.service';
import { SessionResumedTrackingEvent, TrackingInput } from '@app/@core/models/tracking-event.model';

@Injectable({
  providedIn: 'root'
})
export class LoginService {

  constructor(private httpBackEnd: HttpBackend, private httpClient: HttpClient, private instrumentationService: InstrumentationService) { }
  /**
   * @param  {} mobileNoAsPayload
   * return Observable<>
   */
  sendOTP(mobileNoAsPayload): Observable<any> {
    const url = environment.without_auth_url + SEND_OTP_URL;
    const sendOtpReq = new HttpRequest('POST', url, mobileNoAsPayload);
    return this.httpBackEnd.handle(sendOtpReq);
    // return this.httpClient.post(url, null);

  }

  verifyOTP(verifyOtpPayload): Observable<any> {
    const url = environment.without_auth_url + VERIFY_OTP_URL;
    const sendOtpReq = new HttpRequest('POST', url, verifyOtpPayload);
    return this.httpBackEnd.handle(sendOtpReq);
    // return this.httpClient.post(url, verifyOtpPayload);
  }

  sellerBasedOnOrgId() {
    const url = environment.with_auth_url + '/seller/api/v1/seller';
    return this.httpClient.get(url);
  }

  getOnboardingUserDetails() {
    const url = environment.with_auth_url + '/revamped-onboarding/api/v1/user';
    return this.httpClient.get(url);
  }

  refreshToken() {
    const payLoad = {
      userId: sessionStorage.getItem('companyNumber'),
      refreshToken: sessionStorage.getItem('refreshToken')
    };
    return this.httpClient.post(environment.without_auth_url + GET_ACCESSTOKEN_URL, payLoad).pipe(tap((response: any) => {
      if (response !== null && response.data !== null && response.data.accessToken !== null) {
        // this.commonService.store.setAccessToken(response.data.accessToken);
        sessionStorage.setItem('accessToken', response.data.accessToken);
        sessionStorage.setItem('sessionID', uuidv4() || '');
        localStorage.setItem('setSessionStorage', JSON.stringify(sessionStorage));
        localStorage.removeItem('setSessionStorage');
        // Tracking sessevention resume
        const trackingInput: TrackingInput<SessionResumedTrackingEvent> = {
              eventLabel: 'Session Resumed',
              eventName: 'SESSION_RESUMED',
              eventSource: 'Login Page',
              companyNumber: sessionStorage.getItem('companyNumber'),
          };
         this.instrumentationService.logEvent<SessionResumedTrackingEvent>(
              trackingInput
          );
      } else if (response !== null && response.data !== null && response.data.status_code === '400') {
        // this.notifyService.dismissLoader();
      }
    }, (error) => {
      console.log('error for refresh-token api', error);
      // this.notifyService.dismissLoader();
    }));
  }
}
